import { LoadingState } from '@common/components/loading-state';
import React, { lazy, Suspense } from 'react';

const PdfPreview = lazy(() =>
  import('@common/components/pdf-preview').then((mod) => ({
    default: mod.PdfPreview,
  }))
);
const ImagePreview = lazy(() =>
  import('./_file-viewer-image-preview').then((mod) => ({
    default: mod.ImagePreview,
  }))
);
const NotPreviewableFileWarning = lazy(() =>
  import('./_file-viewer-not-previewable-file').then((mod) => ({
    default: mod.NotPreviewableFile,
  }))
);

type FilePreviewProps = {
  contentType: string;
  assetUrl: string;
  fileName?: string;
  width?: number | string;
  height?: number | string;
};

const componentMap = new Map([
  // TODO(WORK-11823): send the content type from all FileViewer call sites and drop forceBackwardsCompatibility
  ['forceBackwardsCompatibility', PdfPreview],
  ['application/pdf', PdfPreview],
  ['image/jpg', ImagePreview],
  ['image/jpeg', ImagePreview],
  ['image/png', ImagePreview],
  ['image/gif', ImagePreview],
  ['image/heic', ImagePreview],
  ['image/heif', ImagePreview],
  ['image/webp', ImagePreview],
]);

export const FilePreview = ({ contentType, ...props }: FilePreviewProps) => {
  const ChosenComponent = componentMap.get(contentType);

  return (
    <Suspense fallback={<LoadingState className="file-preview__loader" />}>
      {ChosenComponent ? (
        <ChosenComponent {...props} />
      ) : (
        <NotPreviewableFileWarning />
      )}
    </Suspense>
  );
};
